import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

import { ReactComponent as AILoadingAnimation } from 'images/ai-stars-animation.svg';

import styles from './AIThinkingLoader.module.scss';

interface AIThinkingLoaderProps {
  animating?: boolean;
  className?: string;
}

const AIThinkingLoader = ({ animating = true, className }: AIThinkingLoaderProps) => {
  const [showSlowLoadingText, setShowSlowLoadingText] = useState(false);

  useEffect(() => {
    if (!animating) {
      setShowSlowLoadingText(false);
      return;
    }
    const timer = setTimeout(() => setShowSlowLoadingText(true), 5000);
    return () => clearTimeout(timer);
  }, [animating]);

  return (
    <div className={clsx(styles.container, { [styles.show]: animating }, className)}>
      <AILoadingAnimation />
      <p className={styles.text}>Thinking.{showSlowLoadingText && ' This might take a few seconds.'}</p>
    </div>
  );
};

export default AIThinkingLoader;
